(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory(root);
  else root.PampasB2BLeads = factory(root);
})(typeof window !== 'undefined' ? window : globalThis, function (root) {
  'use strict';
  function publish(name, data) {
    try {
      const analytics = root.Shopify && root.Shopify.analytics;
      if (analytics && typeof analytics.publish === 'function') {
        Promise.resolve(analytics.publish(name, { ...data })).catch(() => {});
      }
    } catch (_) {}
    try {
      const privacy = root.Shopify && root.Shopify.customerPrivacy;
      if (privacy && privacy.analyticsProcessingAllowed() === true && privacy.marketingAllowed() === true) {
        root.dataLayer = root.dataLayer || [];
        root.dataLayer.push({ event: name, ...data });
      }
    } catch (_) {}
  }
  function create(options) {
    const entries = new Map();
    const conversions = new Map();
    const send = options.fetch || fetch;
    const emit = options.publish || publish;
    const now = options.now || Date.now;
    const uuid = options.uuid || (() => crypto.randomUUID());
    function reset() { entries.clear(); }
    function notify(entry) {
      for (const [key, timestamp] of conversions) if (now() - timestamp > 1800000) conversions.delete(key);
      if (conversions.has(entry.conversionKey)) return;
      conversions.set(entry.conversionKey, now());
      try { Promise.resolve(emit(entry.eventName, { ...entry.eventData })).catch(() => {}); } catch (_) {}
    }
    async function deliver(entry) {
      for (let attempt = 0; attempt < 2; attempt++) {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 3500);
        try {
          const response = await send(options.endpoint, { method: 'POST', credentials: 'omit', mode: 'cors',
            headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: entry.body,
            keepalive: true, signal: controller.signal });
          if (response.ok) {
            const result = await response.json();
            if (!result || result.ok !== true) return false;
            entry.saved = true;
            notify(entry);
            return true;
          }
          if (response.status >= 400 && response.status < 500) return false;
        } catch (_) {
        } finally { clearTimeout(timer); }
      }
      return false;
    }
    function capture(payload) {
      if (!options.endpoint) return Promise.resolve(false);
      try {
        const signature = JSON.stringify(payload);
        for (const [key, entry] of entries) if (now() - entry.created > 120000) entries.delete(key);
        let entry = entries.get(signature);
        if (!entry) {
          const id = uuid();
          entry = { body: JSON.stringify({ ...payload, id }), created: now(), saved: false, pending: null,
            conversionKey: JSON.stringify({ brief: payload.brief, items: payload.items, preview: Boolean(payload.preview) }),
            eventName: payload.preview ? 'pampas_b2b_lead_test' : 'pampas_b2b_lead',
            eventData: { event_id: id, form_id: 'pampas_b2b',
              lead_channel: payload.channel === 'email' ? 'email' : 'whatsapp',
              lead_type: payload.brief && payload.brief.mode === 'budget' ? 'budget' : 'selection',
              selected_product_count: Array.isArray(payload.items) ? payload.items.length : 0,
              lead_status: 'saved', is_test: Boolean(payload.preview) } };
          entries.set(signature, entry);
        }
        if (entry.saved) return Promise.resolve(true);
        if (entry.pending) return entry.pending;
        entry.pending = deliver(entry).finally(() => { entry.pending = null; });
        return entry.pending;
      } catch (_) { return Promise.resolve(false); }
    }
    async function captureReceipt(payload) {
      const saved = await capture(payload);
      if (!saved) return null;
      const entry = entries.get(JSON.stringify(payload));
      return entry && entry.saved ? { id: JSON.parse(entry.body).id } : null;
    }
    return { capture, captureReceipt, reset };
  }
  return { create };
});
